import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Footer from './footer';
import Navbar from './navbar';
// import NavbarMobile from './navbarMobile';

const TermsPage = () => {

     useEffect(() => {
            window.scrollTo(0, 0);
          }, []);



          const schemaData = {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Toodhu Terms of Service",
            "url": "https://toodhu.com/terms",
            "description": "Read our Terms of Services to understand our policies, user rights, and responsibilities. Stay informed about our guidelines for a smooth experience.",
            "inLanguage": "en",
            "isPartOf": {
              "@type": "WebSite",
              "name": "Toodhu",
              "url": "https://toodhu.com"
            },
            "breadcrumb": {
              "@type": "BreadcrumbList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "Home",
                  "item": "https://toodhu.com"
                },
                {
                  "@type": "ListItem",
                  "position": 2,
                  "name": "Terms of Service",
                  "item": "https://toodhu.com/terms"
                }
              ]
            },
            "about": {
              "@type": "WebPage",
              "name": "Terms of Service",
              "description": "Our Terms of Service outline the policies, user rights, and responsibilities when using Toodhu’s platform. Read carefully for a smooth experience.",
              "provider": {
                "@type": "Organization",
                "name": "Toodhu",
                "url": "https://toodhu.com"
              }
            }
          };



  return (

<>
<Helmet>

<title>Understand Our Terms of Services | Toodhu</title>
<meta charset="utf-8"/>
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1" />
<meta name="description" content="Read our Terms of Services to understand our policies, user rights, and responsibilities. Stay informed about our guidelines for a smooth experience."/>
<meta name="keywords" content="Toodhu terms of services, User rights, Toodhu policies"/>
<link rel="canonical" href="https://toodhu.com/terms-of-service" />
<meta name="robots" content="index,follow"/>
<meta property="og:title" content="Understand Our Terms of Services | Toodhu"/>
<meta property="og:site_name" content="Toodhu"/>
<meta property="og:url" content="https://toodhu.com/terms-of-service"/>
<meta property="og:description" content="Read our Terms of Services to understand our policies, user rights, and responsibilities. Stay informed about our guidelines for a smooth experience."/>
<meta property="og:type" content="website"/>
<meta property="og:image" content=""/>
<meta name="twitter:card" content="summary_large_image"/>
<meta name="twitter:site" content="https://toodhu.com/terms-of-service"/>
<meta name="twitter:title" content="Understand Our Terms of Services | Toodhu"/>
<meta name="twitter:description" content="Read our Terms of Services to understand our policies, user rights, and responsibilities. Stay informed about our guidelines for a smooth experience."/>
<meta name="twitter:image" content=""></meta>
<script type="application/ld+json">{JSON.stringify(schemaData)}</script>

</Helmet>

<div>
<div>
      <Navbar/>
    </div>

<div className="container py-5">
      <h1 className="mb-4 text-center mt-14">Terms of Service</h1>
      
      <section className="mb-5">
        <h2>Introduction</h2>
        <p>Welcome to Toodhu Terms of Service. These terms, along with Toodhu <span ><a className='privacyangrtag' href='/privacy'>Privacy Statement</a></span> and Support Access and Service Level Agreement and API Development Agreement (collectively, the “Terms”), govern your use of Toodhu’s Website, API, and Software (together referred to as the “Services”). These policies may be updated periodically, and they outline the conditions for accessing and using Toodhu’s Services.</p>
      </section>
      
      <section className="mb-5">
        <h2>Access and Use of Services</h2>
        <p>Toodhu grants you access to its services under a subscription-based model. By subscribing, you confirm that you have the authority to accept these Terms and that your use of the services will not breach any third-party agreements or laws.</p>
      </section>
      
      <section className="mb-5">
        <h2>Service Duration and SLA</h2>
        <p>Your right to use Toodhu services lasts as long as your subscription is active, and during that time, you are entitled to the benefits outlined in Toodhu current Service Level Agreement (SLA).</p>
      </section>

      <section className="mb-5">
        <h2>Modifications and Termination</h2>
        <p>Toodhu reserves the right to modify or discontinue its services at any time, with or without prior notice after termination of subscription.</p>
      </section>

      <section className="mb-5">
        <h2>Disclaimer of Warranties</h2>
        <p>Toodhu provides its services “as-is” and “as available,” and to the extent allowed by law, Toodhu and its partners disclaim all warranties, whether express, implied, or statutory.</p>
      </section>

      <section className="mb-5">
        <h2>Limitation of Liability</h2>
        <p>Toodhu is not responsible for any direct, indirect, incidental, or consequential damages that result from your use of the services.</p>
      </section>

      <section className="mb-5">
        <h2>Support and Service Responsibilities</h2>
        <p>Toodhu offers automatic updates and support for its system, as described in the Support Access Agreement.</p>
      </section>

      <section className="mb-5">
        <h2>Intellectual Property</h2>
        <p>You are not allowed to copy, modify, or distribute any content from Toodhu’s services for commercial purposes without explicit permission.</p>
      </section>

      <section className="mb-5">
        <h2>Miscellaneous</h2>
        <p>These Terms are governed by the laws of India, and any disputes will be resolved in the courts of Coimbatore, Tamil Nadu.</p>
      </section>

      <section className="mb-5">
        <h2>About Toodhu</h2>
        <p>Toodhu delivers an environment through which high-quality firms from diverse backgrounds can work together toward their own common goals.</p>
      </section>
    </div>

    <div>
      <Footer/>
    </div>


</div>

</>


  );
};

export default TermsPage;
